"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm.779 14.893H11.22v-1.557h1.558v1.557zm0-3.13H11.22V7.107h1.558v6.656z" }), "Alert");
//# sourceMappingURL=Alert.js.map